import React from "react";
import SIPCalculator from "./components/SIPCalculator";
import SWPCalculator from "./components/SWPCalculator";
import InflationCalculator from "./components/InflationCalculator";
import CAGRCalculator from "./components/CAGRCalculator";
import ReverseCAGRCalculator from "./components/ReverseCAGRCalculator";
import XIRRCalculator from "./components/XIRRCalculator";

export default function App({ type }) {
  switch (type) {
    case "sip":
      return <SIPCalculator />;
    case "swp":
      return <SWPCalculator />;
    case "inflation":
      return <InflationCalculator />;
    case "cagr":
      return <CAGRCalculator />;
    case "reverse_cagr":
      return <ReverseCAGRCalculator />;
    case "xirr":
      return <XIRRCalculator />;  
    default:
      return <div>Unknown calculator type</div>;
  }
}
